import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  pointPersonLink: {
    cursor: 'pointer',
    color: 'inherit !important',
    textDecoration: 'inherit !important',
  },
  addTeamMemberLink: {
    margin: 'auto',
    width: '50%',
    color: '#1C2541',
  },
  link: {
    cursor: 'pointer',
  },
}));
